import React, { useState } from 'react';
import './MenuPage.css';
import darkChocolateTruffle from '../assets/dark-chocolate-truffle.jpg';
import nutellaChocoTruffle from '../assets/nutella-choco-truffle.jpg';
import blackForest from '../assets/black-forest.jpg';
import paanCake from '../assets/paan-cake.jpg';
import oreoCake from '../assets/oreo-cake.jpg';
import strawberryCake from '../assets/strawberry-cake.jpg';
import vanillaDelight from '../assets/vanilla-delight.jpg';
import roseCake from '../assets/rose-cake.jpg';
import rasmalaiCake from '../assets/rasmalai-cake.jpg';
import mixedFruitCake from '../assets/mixed-fruit-cake.jpg';
import pineappleCake from '../assets/pineapple-cake.jpg';
import whiteForest from '../assets/white-forest.jpg';
import pistaCake from '../assets/pista-cake.jpg';
import dutchTruffle from '../assets/dutch-truffle.jpg';
import ferreroRocherCake from '../assets/ferrero-rocher-cake.jpg';
import blueberryCake from '../assets/blueberry-cake.jpg';
import belgianChocolate from '../assets/belgian-chocolate.jpg';
import redVelvet from '../assets/red-velvet.jpg';
import butterscotchCake from '../assets/butterscotch-cake.jpg';
import coffeeCake from '../assets/coffee-cake.jpg';
import cupcake1 from '../assets/cupcake1.jpg';
import cupcake2 from '../assets/cupcake2.jpg';
import cupcake3 from '../assets/cupcake3.jpg';
import cupcake4 from '../assets/cupcake4.jpg';

const cakeFlavours = [
  { name: 'Dark Chocolate Truffle', description: 'Rich, decadent chocolate layers with smooth truffle cream', image: darkChocolateTruffle },
  { name: 'Nutella Choco Truffle', description: 'Heavenly Nutella-infused chocolate delight', image: nutellaChocoTruffle },
  { name: 'Black Forest', description: 'Classic chocolate cake with cherries and whipped cream', image: blackForest },
  { name: 'Paan', description: 'Unique Indian flavor with a refreshing twist', image: paanCake },
  { name: 'Oreo', description: 'Cookies and cream perfection in every bite', image: oreoCake },
  { name: 'Strawberry', description: 'Fresh strawberry cream with soft vanilla sponge', image: strawberryCake },
  { name: 'Vanilla Delight', description: 'Pure vanilla bliss with creamy frosting', image: vanillaDelight },
  { name: 'Rose', description: 'Delicate rose-flavored cake with floral notes', image: roseCake },
  { name: 'Rasmalai', description: 'Traditional Indian dessert in cake form', image: rasmalaiCake },
  { name: 'Mixed Fruit', description: 'Tropical fruits with light cream', image: mixedFruitCake },
  { name: 'Pineapple', description: 'Tangy pineapple with fluffy sponge', image: pineappleCake },
  { name: 'White Forest', description: 'White chocolate variant of the classic', image: whiteForest },
  { name: 'Pista', description: 'Rich pistachio flavor with nuts', image: pistaCake },
  { name: 'Dutch Truffle', description: 'Premium Dutch chocolate truffle', image: dutchTruffle },
  { name: 'Ferrero Rocher', description: 'Hazelnut chocolate luxury', image: ferreroRocherCake },
  { name: 'Blueberry', description: 'Fresh blueberries with cream cheese frosting', image: blueberryCake },
  { name: 'Belgian Chocolate', description: 'Premium Belgian chocolate indulgence', image: belgianChocolate },
  { name: 'Red Velvet', description: 'Classic red velvet with cream cheese', image: redVelvet },
  { name: 'Butterscotch', description: 'Caramel butterscotch delight', image: butterscotchCake },
  { name: 'Coffee', description: 'Rich coffee-flavored layers', image: coffeeCake },
];

const cupcakeFlavours = [
  { name: 'Chocolate', description: 'Classic chocolate cupcake with rich frosting', image: cupcake1 },
  { name: 'Vanilla', description: 'Light and fluffy vanilla perfection', image: cupcake2 },
  { name: 'Choco Chips', description: 'Chocolate chip studded delight', image: cupcake3 },
  { name: 'Fruits', description: 'Fresh fruit-topped cupcakes', image: cupcake4 },
];

const MenuPage = () => {
  const [activeTab, setActiveTab] = useState('cakes');

  return (
    <div className="menu-page">
      <div className="menu-header">
        <h1 className="page-title">Our Flavours</h1>
        <p className="menu-subtitle">Handcrafted with love, baked to perfection</p>
      </div>

      {/* Tab Navigation */}
      <div className="menu-tabs">
        <button
          className={`tab-btn ${activeTab === 'cakes' ? 'active' : ''}`}
          onClick={() => setActiveTab('cakes')}
        >
          Cake Flavours
        </button>
        <button
          className={`tab-btn ${activeTab === 'cupcakes' ? 'active' : ''}`}
          onClick={() => setActiveTab('cupcakes')}
        >
          Cupcake Flavours
        </button>
      </div>

      {/* Flavour Cards Grid */}
      <div className="flavours-container">
        {activeTab === 'cakes' && (
          <div className="flavours-grid">
            {cakeFlavours.map((flavour, index) => (
              <div key={index} className="flavour-card">
                <div className="flavour-image-wrapper">
                  <img
                    src={flavour.image}
                    alt={flavour.name}
                    className="flavour-image"
                    loading="lazy"
                  />
                </div>
                <h3 className="flavour-name">{flavour.name}</h3>
                <p className="flavour-description">{flavour.description}</p>
              </div>
            ))}
          </div>
        )}

        {activeTab === 'cupcakes' && (
          <div className="flavours-grid">
            {cupcakeFlavours.map((flavour, index) => (
              <div key={index} className="flavour-card">
                <div className="flavour-image-wrapper">
                  <img
                    src={flavour.image}
                    alt={flavour.name}
                    className="flavour-image"
                    loading="lazy"
                  />
                </div>
                <h3 className="flavour-name">{flavour.name}</h3>
                <p className="flavour-description">{flavour.description}</p>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Order Information */}
      <div className="order-section">
        <h2 className="order-title">How to Order</h2>
        <p className="order-description">
          To help us deliver you on time, we suggest you to place your order at least 48 hours in advance.
          Please call to place the order. Orders are confirmed after 50% advance payment.
        </p>

        <div className="order-details">
          <div className="order-detail-item">
            <div className="detail-icon">📞</div>
            <div className="detail-content">
              <h3>Contact Number</h3>
              <p className="phone-number">8668281565</p>
              <p className="detail-note">Available for orders and inquiries</p>
            </div>
          </div>

          <div className="order-detail-item">
            <div className="detail-icon">⏰</div>
            <div className="detail-content">
              <h3>Advance Notice</h3>
              <p className="detail-highlight">Minimum 48 Hours</p>
              <p className="detail-note">For best quality and timely delivery</p>
            </div>
          </div>

          <div className="order-detail-item">
            <div className="detail-icon">💳</div>
            <div className="detail-content">
              <h3>Payment Terms</h3>
              <p className="detail-highlight">50% Advance Required</p>
              <p className="detail-note">Balance on pickup</p>
            </div>
          </div>

          <div className="order-detail-item">
            <div className="detail-icon">📍</div>
            <div className="detail-content">
              <h3>Pickup Only</h3>
              <p className="detail-highlight">Self Collection</p>
              <p className="detail-note">No delivery service available</p>
            </div>
          </div>
        </div>

        <p className="tagline">"Baking is fun and Passion both."</p>
      </div>
    </div>
  );
};

export default MenuPage;
